import { render, staticRenderFns } from "./Welcome_HeNan.vue?vue&type=template&id=8641898a&scoped=true&"
import script from "./Welcome_HeNan.vue?vue&type=script&lang=js&"
export * from "./Welcome_HeNan.vue?vue&type=script&lang=js&"
import style0 from "./Welcome_HeNan.vue?vue&type=style&index=0&id=8641898a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8641898a",
  null
  
)

export default component.exports